/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import * as io from 'io-ts';
import { SegmentCondition } from '../SegmentCondition/SegmentCondition.entity';

/**
 * The dxp segment entity type.
 */
export type EntitySegment = io.TypeOf<typeof Segment>;

/**
 * The dxp segment entity definition.
 * @export
 */
export const Segment = io.intersection(
  [
    io.type({
      code: io.string,
      conditions: SegmentCondition,
      description: io.string,
      name: io.string,
    }),
    io.partial({
      internalId: io.string,
      success: io.record(
        io.string,
        io.type({
          metricid: io.union([io.string, io.null]),
        }),
      ),
    }),
  ],
  `Segment`,
);
